import React from 'react'
import PropTypes from 'prop-types'

import ImageMessage from './ImageMessage'
import VideoMessage from './VideoMessage'
import TextMessage from './TextMessage'
import AudioMessage from './AudioMessage'
import LocationMessage from './LocationMessage'
import FileMessage from './FileMessage'
import SimpleWidget from './SimpleWidget'
import ActionWidget from './ActionWidget'

const Widget = props => {
  const { type, payload, isLeft, avatar, endOfBlock, createdAt, isDim } = props
  if (!payload) {
    console.error('Expected a payload', props)
    return null
  }

  switch (type) {
    case 'image':
      return (
        <ImageMessage
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
    case 'file':
      return (
        <FileMessage
          isLeft={isLeft}
          payload={payload}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
    case 'animation':
    case 'video':
      return (
        <VideoMessage
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
    case 'audio':
      return (
        <AudioMessage
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
    case 'location':
      return (
        <LocationMessage
          isLeft={isLeft}
          payload={payload}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
    case 'phone_dial':
    case 'phone_hangup':
    case 'event':
    case 'nothing':
    case 'trigger':
      return <ActionWidget
        action={type}
        isLeft={isLeft}
        payload={payload}
        avatar={avatar}
        endOfBlock={endOfBlock}
        createdAt={createdAt}
      />
    case 'buttons':
    case 'card':
    case 'list':
    case 'carousel':
      return (
        <SimpleWidget
          type={type}
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />
      )
    case 'phone_ask':
    case 'phone_say':
      return payload?.url
        ? (<AudioMessage
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
        : (<TextMessage
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
    case 'text':
    default:
      return (
        <TextMessage
          isDim={isDim}
          payload={payload}
          isLeft={isLeft}
          avatar={avatar}
          endOfBlock={endOfBlock}
          createdAt={createdAt}
        />)
  }

}

export default Widget

Widget.propTypes = {
  type: PropTypes.string.isRequired,
  payload: PropTypes.object.isRequired,
  isLeft: PropTypes.bool,
  endOfBlock: PropTypes.bool,
  avatar: PropTypes.any,
  createdAt: PropTypes.instanceOf(Date).isRequired,
  isDim: PropTypes.bool
}
